import React from "react";
import { useTranslation } from "react-i18next";

const OrderLoading: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className="OrderContainer">
			<p>{t("orderConfirmation.loadingOrderDetails")}</p>
		</div>
	);
};

export default OrderLoading;
